import { Group, TextInput, rem, Checkbox } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useDebouncedCallback } from "use-debounce";
import { useAppTranslation } from "hooks/useTranslation";

interface OrganizersSearchFilterProps {
  onUpdateName?: (name: string) => void;
  onUpdateActiveOnly?: (activeOnly: boolean) => void;
  activeOnly?: boolean;
}

export const OrganizersSearchFilter = (props: OrganizersSearchFilterProps) => {
  const { onUpdateName, onUpdateActiveOnly, activeOnly } = props;
  const { t } = useAppTranslation();

  const debouncedTitle = useDebouncedCallback(
    (value) => {
      onUpdateName && onUpdateName(value);
    },
    // delay in ms
    500
  );

  return (
    <Group>
      <TextInput
        label=""
        placeholder={t("organizers.name")}
        leftSection={<IconSearch style={{ width: rem(16), height: rem(16) }} />}
        onChange={(organizer) => debouncedTitle(organizer.currentTarget.value)}
      />
      <Checkbox
        label={t("organizers.active_only")}
        checked={activeOnly}
        onChange={(event) =>
          onUpdateActiveOnly && onUpdateActiveOnly(event.currentTarget.checked)
        }
      />
    </Group>
  );
};
